<label class="cm-container">
    <input name="checkboxValue" type="checkbox" [(ngModel)]="$value" (ngModelChange)="onValueChange()" [ngModelOptions]="{standalone: true}" />
    <i class="fa-light fa-square cm-unchecked"></i>
    <i class="fa-regular fa-square-check cm-checked"></i>
    <ng-content></ng-content>
</label>
